(function() {
  'use strict';

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(function(item) {
    var question = item.querySelector('.faq-question');
    if (!question) return;
    question.addEventListener('click', function() {
      var wasOpen = item.classList.contains('open');
      var parent = item.parentElement;
      if (parent) {
        parent.querySelectorAll('.faq-item.open').forEach(function(openItem) {
          openItem.classList.remove('open');
        });
      }
      if (!wasOpen) {
        item.classList.add('open');
      }
    });
  });

  // Projects discipline filter
  var filterButtons = document.querySelectorAll('.discipline-filter button');
  var tiles = document.querySelectorAll('.project-tile');

  filterButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var filter = this.getAttribute('data-filter');
      filterButtons.forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      tiles.forEach(function(tile) {
        var discipline = tile.getAttribute('data-discipline') || '';
        var disciplines = discipline.split(/\s+/).filter(Boolean);
        if (filter === 'all' || disciplines.indexOf(filter) !== -1) {
          tile.style.display = 'flex';
        } else {
          tile.style.display = 'none';
        }
      });
    });
  });

  // Receipts marquee: duplicate track content for seamless loop
  var tracks = document.querySelectorAll('.receipts-track');
  tracks.forEach(function(track) {
    var children = Array.from(track.children);
    children.forEach(function(child) {
      var clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  });

  // Mobile nav toggle
  var navToggle = document.querySelector('.nav-toggle');
  var siteNav = document.querySelector('.site-nav');
  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function() {
      var isOpen = navToggle.classList.contains('is-open');
      navToggle.classList.toggle('is-open');
      siteNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', String(!isOpen));
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });
    siteNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        navToggle.classList.remove('is-open');
        siteNav.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && navToggle.classList.contains('is-open')) {
        navToggle.classList.remove('is-open');
        siteNav.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }
  
  // Respect prefers-reduced-motion for marquee
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  function handleReducedMotion() {
    tracks.forEach(function(track) {
      if (motionQuery.matches) {
        track.style.animationPlayState = 'paused';
      } else {
        track.style.animationPlayState = 'running';
      }
    });
  }
  handleReducedMotion();
  motionQuery.addEventListener('change', handleReducedMotion);

})();
